import { DefaultSelection36RfiReopenPayload, IRFIReopenApproval } from "../api-generated";

export default class RFIReopenApprovalDetail
  implements IRFIReopenApproval
{
  public Guid: string;

  constructor(item: DefaultSelection36RfiReopenPayload) {
    this.Guid = item.Guid;
  }
}
